import { INSTANCE_TYPE } from "~/assets/js/constants";

export default {
  async fetch({ dispatch, commit }) {
    commit("SET_LOADING", true);
    try {
      await dispatch("setInstances");
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async setInstances({ commit, state, rootGetters }) {
    const { page, sortBy, orderBy, search: filter } = state;
    const size = rootGetters["application/getPageSize"];
    const defaultFilter = `type:${INSTANCE_TYPE.FEDERATED}`;

    try {
      const instances = await this.$services.instance.fetch({
        size,
        page,
        sortBy,
        orderBy,
        filter,
        defaultFilter,
      });
      commit("SET_INSTANCES", instances);
    } catch (error) {
      throw new Error(error);
    }
  },

  async setInstance({ commit, dispatch }, { savedInstance, id }) {
    try {
      const instance = await this.$services.instance.patch(id, savedInstance);
      commit("SET_INSTANCE", instance);
      dispatch("application/updateFederatedNavLink", instance, { root: true });
      this.$feedback.ok("feedback.update.instance.ok");
    } catch {
      this.$feedback.error("feedback.update.instance.error");
    }
  },

  async addInstance({ commit, dispatch }, instance) {
    try {
      const addedInstance = await this.$services.instance.create(instance);
      commit("ADD_INSTANCE", addedInstance);
      dispatch("application/addFederatedNavLink", addedInstance, { root: true });
      this.$feedback.ok("feedback.create.instance.ok");
    } catch (error) {
      const { error: prefix, message } = error.response.data;
      this.$feedback.error(`${prefix}${message}`);
    }
  },

  async deleteInstance({ commit, dispatch }, id) {
    try {
      await this.$services.instance.remove(id);
      commit("DELETE_INSTANCE", id);
      dispatch("application/removeFederatedNavLink", id, { root: true });
      this.$feedback.ok("feedback.delete.instance.ok");
    } catch {
      this.$feedback.error("feedback.delete.instance.error");
    }
  },

  async fetchInstance({ commit }, id) {
    try {
      const editingInstance = await this.$services.instance.fetchOne(id);
      commit("SET_EDITING_INSTANCE", editingInstance);
    } catch (error) {
      throw new Error(error);
    }
  },
};
